import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import es from './locales/es/v2.json'
import en from './locales/en/v2.json'
import it from './locales/it/v2.json'
import fr from './locales/fr/v2.json'

export const LANGUAGES = ['es', 'en', 'it', 'fr'] as const
export type Language = (typeof LANGUAGES)[number]
const LANGUAGE_PREFERENCE_KEY = 'v2.language'

// Código de idioma que espera la API del PMS (la app actual usa "gb" para inglés).
export const API_LOCALE: Record<Language, string> = { es: 'es', en: 'gb', it: 'it', fr: 'fr' }

export function isLanguage(value: string | null | undefined): value is Language {
  return LANGUAGES.includes(value as Language)
}

/**
 * El idioma de la app siempre sigue las preferencias del navegador/dispositivo.
 * Se revisan en orden para respetar la preferencia principal y se usa inglés si
 * ninguna está disponible en la aplicación.
 */
export function detectLanguage(navigatorLanguages: readonly string[] = navigator.languages): Language {
  for (const navigatorLanguage of navigatorLanguages) {
    const base = navigatorLanguage.split('-')[0]?.toLowerCase() ?? ''
    if (isLanguage(base)) return base
  }
  return 'en'
}

/** Preferencia manual elegida desde Perfil; si no existe se usa el idioma del dispositivo. */
export function savedLanguage(): Language | null {
  try {
    const language = localStorage.getItem(LANGUAGE_PREFERENCE_KEY)
    return isLanguage(language) ? language : null
  } catch {
    return null
  }
}

export function saveLanguage(language: Language) {
  try {
    localStorage.setItem(LANGUAGE_PREFERENCE_KEY, language)
  } catch {
    /* sin almacenamiento: el cambio se mantiene durante esta sesión */
  }
}

const resources = {
  es: { translation: es },
  en: { translation: en },
  it: { translation: it },
  fr: { translation: fr },
}

void i18n.use(initReactI18next).init({
  resources,
  lng: typeof window === 'undefined' ? 'en' : (savedLanguage() ?? detectLanguage()),
  fallbackLng: 'en',
  supportedLngs: [...LANGUAGES],
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
